/**
 * @file index
 * @author dingzhenyue
 * @desc 法律角色拦截，未认证的律师进行页面拦截
 */
import store from '@/store/index';


export const lawyerNotCertifiedIntercept = (to, from, next) => {
    let lawStore = store.state.lawStore || {};
    let authenticationStatus = lawStore.authenticationStatus;
    // 未完成执业认证
    if (+authenticationStatus && +authenticationStatus < 4) {
        if (to.path === '/lawinfo/lawverifyguide' || to.path === '/material' || to.path === '/businessCenter') {
            next();
        }
        else if (from.path === '/lawinfo/lawverifyguide') {
            next(false);
        }
        else {
            next('/lawinfo/lawverifyguide');
        }
        return;
    }
    next();
};
